import { JakeArnoldForLG, getStaticProps } from '@public/JakeArnoldForLG'

export { getStaticProps }

export default JakeArnoldForLG
